import { DigoService } from 'src/app/services/digo.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatService } from 'src/app/home/services/chat.service';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-chat-history-modal',
    templateUrl: './chat-history-modal.component.html',
    styleUrls: ['./chat-history-modal.component.css'],
    standalone: false
})
export class ChatHistoryModalComponent implements OnInit {

    @Input() chats$!: Observable<any[]>;
    public chats: any[] = [];
    chatSelected = null;
    public pdvInfo: any = null;
    chatParentSelected = null;
    public chatsLoading = true;
    public messagesLoading = false;

    constructor(
        public activeModal: NgbActiveModal,
        public chatService: ChatService,
        private digoService: DigoService
    ) { }

    ngOnInit(): void {
        // Esperar al primer snapshot real (archivedChatsReady) para no pintar empty con el [] inicial
        this.chatService.archivedChatsReady$.pipe(
            filter(ready => ready),
            switchMap(() => this.chats$)
        ).subscribe(chats => {

            if (!chats?.length) {
                this.chats = [];
                this.chatsLoading = false;
                return;
            }

            const distributorIds = [...new Set(chats.map(c => c.id_distribuidor).filter(Boolean))];

            const existing = this.chatService.getDistributors();
            const existingIds = existing.map(d => Number(d.id_distribuidor));
            const missingIds = distributorIds.filter(id => !existingIds.includes(id));


            if (!missingIds.length) {
                this.chats = this.chatService.normalizeThread(chats);
                this.chatsLoading = false;
                return;
            }

            this.digoService.getDistributorsByIds(missingIds).subscribe(distributors => {
                this.chatService.setDistributors(Object.values(distributors));
                this.chats = this.chatService.normalizeThread(chats);
                this.chatsLoading = false;
            });

        });

        this.digoService.getPDV()
        .subscribe((data) => {
            if (data) {
                this.pdvInfo = data;
            }
        });
    }

    openChatHistory(chat) {
        this.chatParentSelected = chat;
        this.messagesLoading = true;
        this.chatSelected = null;
        this.chatService.getArchivedChatByIdFromFilestore(chat.id).then(messages => {
            this.chatSelected = this.chatService.normalizeMessages(messages, this.pdvInfo);
            this.messagesLoading = false;
        });
    }

    closeDialog() {
        this.activeModal.close();
    }

}
